export default "__VITE_ASSET__BnVzR4Cw__"